var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-without-border",attrs:{"text":"","dark":"","title":"Odmítnout"},on:{"click":function($event){$event.stopPropagation();return _vm.decline($event)}}},[_vm._v(" Odmítnout ")])}
var staticRenderFns = []

export { render, staticRenderFns }